module.exports = __webpack_public_path__ + "static/media/1.40c71700.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_190/images/九宫格选中态/1.png
// module id = 1627
// module chunks = 0